import { registerLocale, setDefaultLocale } from 'react-datepicker';
import { lt } from 'date-fns/locale';
import { config } from '../../api/config';
import './date-picker.css';

export const registerDatePickerLocale = () => {
  registerLocale(config.DEFAULTS.locale, lt);
  setDefaultLocale(config.DEFAULTS.locale);
};
